import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "mb-14 p-4 border-[3px] border-cebai-grey-lighter rounded-2xl relative" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_3 = { class: "w-8" }
const _hoisted_4 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_5 = { class: "w-8" }
const _hoisted_6 = { ref: "expandedContentEl" }
const _hoisted_7 = { class: "lg:flex mt-4 mb-6" }
const _hoisted_8 = { class: "md:flex items-center flex-1 lg:mr-4 mb-6 lg:mb-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "flex-none mr-2 mb-2 md:mb-0 text-cebai-grey-dark w-16" }, " Subjects: ", -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "md:flex items-center flex-1 lg:ml-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "flex-none mr-2 mb-2 lg:mb-0 text-cebai-grey-dark w-16" }, " Topics: ", -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "md:flex items-center mb-6"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "flex-none mr-2 mb-2 md:mb-0 text-cebai-grey-dark w-16" }, " Tags: ", -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "md:flex items-center justify-between" }
const _hoisted_18 = { class: "flex pb-6" }
const _hoisted_19 = {
  key: 0,
  class: "mr-6"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-grey-dark inline-block mr-1" }, "Created:", -1)
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-grey-dark inline-block mr-1" }, "Last updated:", -1)
const _hoisted_23 = { class: "flex justify-between md:justify-start pb-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, " Are you sure you want to delete this challenge? This can't be undone. ", -1)
const _hoisted_25 = { class: "flex justify-center mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!
  const _component_AutoResizeTextarea = _resolveComponent("AutoResizeTextarea")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_BinIcon = _resolveComponent("BinIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_MinusIcon = _resolveComponent("MinusIcon")!
  const _component_Editorial = _resolveComponent("Editorial")!
  const _component_ModalContent = _resolveComponent("ModalContent")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_LoadingIcon, { class: "text-cebai-primary" })
            ])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.isLoadingChallengeTitle)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_LoadingIcon, { class: "text-cebai-primary" })
                  ])
                ]))
              : (_openBlock(), _createBlock(_component_AutoResizeTextarea, {
                  key: 1,
                  ref: "challengeTitleEl",
                  modelValue: _ctx.challengeTitle,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.challengeTitle) = $event)),
                  readonly: !(_ctx.isExpanded && _ctx.isEditable && _ctx.challengeIsActive),
                  rows: 1,
                  "max-rows": 3,
                  class: "pb-2 md:pb-3 appearance-none placeholder-cebai-grey-dark border-none outline-none text-cebai-base-dark text-base font-robotoMedium caret-cebai-primary w-full resize-none"
                }, null, 8, ["modelValue", "readonly"])),
            _createVNode(_component_AutoResizeTextarea, {
              ref: "challengeDescriptionEl",
              modelValue: _ctx.challengeDescription,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.challengeDescription) = $event)),
              readonly: !(_ctx.isExpanded && _ctx.isEditable && _ctx.challengeIsActive),
              rows: 1,
              "max-rows": 10,
              class: "mb-6 appearance-none placeholder-cebai-grey-dark border-none outline-none text-cebai-base-dark text-base caret-cebai-primary w-full resize-none"
            }, null, 8, ["modelValue", "readonly"]),
            _createElementVNode("div", {
              class: _normalizeClass(["transition-all", {
          'overflow-hidden': !_ctx.isExpanded,
          'overflow-visible': _ctx.isExpanded,
        }]),
              style: _normalizeStyle(`height: ${_ctx.isExpanded ? _ctx.elementHeight : 0}px;`)
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    (_ctx.isEditable && _ctx.challengeIsActive)
                      ? (_openBlock(), _createBlock(_component_Multiselect, {
                          key: 0,
                          modelValue: _ctx.challengeSubjects,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.challengeSubjects) = $event)),
                          mode: "tags",
                          placeholder: "Select 2 maximum",
                          max: 2,
                          groups: _ctx.isAuthenticated,
                          options: 
                    _ctx.isAuthenticated ? _ctx.userSubjectOptions : _ctx.allSubjectOptions
                  ,
                          searchable: true,
                          "can-clear": false,
                          "break-tags": true
                        }, null, 8, ["modelValue", "groups", "options"]))
                      : (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.challengeSubjects, (challengeSubject, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index,
                              class: "inline-block text-sm py-1.5 px-2.5 rounded-lg mr-2 mb-1 bg-cebai-grey-lighter font-robotoMedium"
                            }, _toDisplayString(challengeSubject), 1))
                          }), 128))
                        ]))
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    (_ctx.isEditable && _ctx.challengeIsActive)
                      ? (_openBlock(), _createBlock(_component_Multiselect, {
                          key: 0,
                          modelValue: _ctx.challengeTypes,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.challengeTypes) = $event)),
                          mode: "tags",
                          placeholder: "Select 2 maximum",
                          max: 2,
                          options: _ctx.typesOptions,
                          searchable: true,
                          "can-clear": false,
                          "break-tags": true
                        }, null, 8, ["modelValue", "options"]))
                      : (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.challengeTypes, (challengeType, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index,
                              class: "inline-block text-sm py-1.5 px-2.5 rounded-lg mr-2 mb-1 bg-cebai-grey-lighter font-robotoMedium"
                            }, _toDisplayString(challengeType), 1))
                          }), 128))
                        ]))
                  ])
                ]),
                (_ctx.isEditable || _ctx.challengeTags.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      (_ctx.isEditable && _ctx.challengeIsActive)
                        ? (_openBlock(), _createBlock(_component_Multiselect, {
                            key: 0,
                            modelValue: _ctx.challengeTags,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.challengeTags) = $event)),
                            mode: "tags",
                            "no-options-text": "Type in a tag and press return",
                            "no-results-text": "Type in a tag and press return",
                            placeholder: "Select or type in search tags ...",
                            "close-on-select": false,
                            searchable: true,
                            "create-option": true,
                            options: _ctx.tagsOptions,
                            "can-clear": false,
                            "break-tags": true
                          }, null, 8, ["modelValue", "options"]))
                        : (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.challengeTags, (challengeTag, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: index,
                                class: "inline-block text-sm py-1.5 px-2.5 rounded-lg mr-2 mb-1 bg-cebai-grey-lighter font-robotoMedium"
                              }, _toDisplayString(challengeTag), 1))
                            }), 128))
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.createdAt)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("strong", null, _toDisplayString(_ctx.getRelativeDateString(_ctx.createdAt)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.updatedAt)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("strong", null, _toDisplayString(_ctx.getRelativeDateString(_ctx.updatedAt)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    (_ctx.displayDeleteButton)
                      ? (_openBlock(), _createBlock(_component_AppButton, {
                          key: 0,
                          type: "danger",
                          class: "mr-6 font-robotoMedium",
                          onClick: _ctx.showDeleteChallengeModal
                        }, {
                          iconBefore: _withCtx(() => [
                            _createVNode(_component_BinIcon, { class: "fill-current mr-3" })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" Delete ")
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.isEditable && _ctx.challengeIsActive)
                      ? (_openBlock(), _createBlock(_component_AppButton, {
                          key: 1,
                          type: "secondary",
                          disabled: _ctx.submitIsDisabled,
                          onClick: _ctx.handleUpdate
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Update ")
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 512)
            ], 6),
            _createElementVNode("button", {
              class: "group absolute flex items-center z-10 left-1/2 -translate-x-1/2 px-4 py-2 rounded-full border-[3px] border-cebai-grey-lighter bg-cebai-base-light hover:bg-cebai-grey-lightest text-cebai-grey-dark font-robotoMedium transition",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleExpansionToggle && _ctx.handleExpansionToggle(...args)))
            }, [
              (!_ctx.isExpanded)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" See more "),
                    _createVNode(_component_PlusIcon, { class: "ml-2 text-cebai-primary fill-current" })
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" See less "),
                    _createVNode(_component_MinusIcon, { class: "ml-2 text-cebai-primary fill-current" })
                  ], 64))
            ])
          ], 64))
    ]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.isShown.deleteChallenge,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isShown.deleteChallenge) = $event)),
      close: () => _ctx.closeModal('deleteChallenge')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalContent, {
          close: () => _ctx.closeModal('deleteChallenge'),
          title: "Delete challenge",
          class: "md:max-w-xl"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Editorial, null, {
              default: _withCtx(() => [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_AppButton, {
                    class: "mr-2",
                    type: "secondary",
                    onClick: _cache[6] || (_cache[6] = () => _ctx.closeModal('deleteChallenge'))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancel ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_AppButton, {
                    type: "danger",
                    onClick: _ctx.handleDeleteChallenge
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Delete ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["close"])
      ]),
      _: 1
    }, 8, ["modelValue", "close"])
  ], 64))
}